import { Check } from 'lucide-react';

const ROTULOS = ['CONDUTOR', 'VEÍCULO', 'ROTA', 'DATAS', 'TRAJETO', 'PASSAG.', 'VALOR'];
const NOMES = ['Condutor', 'Veículo', 'Rota', 'Datas', 'Trajeto', 'Passageiros', 'Valor'];

interface Props {
  passoAtual: number;
  /** Com o documento fiscal emitido, a viagem não muda: os passos só informam. */
  travado?: boolean;
  onNavegar: (passo: number) => void;
}

/** Stepper de 7 passos — handoff §2. Concluído: bola cheia com a marca. Atual: número. Futuro: bola vazia. */
export function WizardStepper({ passoAtual, travado, onNavegar }: Props) {
  return (
    <nav aria-label="Passos da emissão">
      <ol className="co-passos">
        {ROTULOS.map((rotulo, i) => {
          const concluido = i < passoAtual;
          const atual = i === passoAtual;
          const estado = concluido ? 'concluído' : atual ? 'atual' : 'a fazer';
          return (
            <li key={rotulo} data-atual={atual || undefined}>
              <div className="co-passos-trilho">
                <span className={`co-passos-linha${i === 0 ? ' co-passos-linha-vazia' : concluido || atual ? ' co-passos-linha-feita' : ''}`} />
                <button
                  type="button"
                  className={`co-passo${concluido ? ' co-passo-feito' : ''}`}
                  aria-current={atual ? 'step' : undefined}
                  aria-label={`Passo ${i + 1}, ${NOMES[i]}: ${estado}`}
                  disabled={travado}
                  onClick={() => onNavegar(i)}
                >
                  {concluido ? <Check size={14} strokeWidth={3} aria-hidden="true" /> : i + 1}
                </button>
                <span className={`co-passos-linha${i === ROTULOS.length - 1 ? ' co-passos-linha-vazia' : concluido ? ' co-passos-linha-feita' : ''}`} />
              </div>
              <span className="co-passo-rotulo" aria-hidden="true">{rotulo}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
